import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '.';
import { User } from '../interface';

export interface UserSliceInterface {
  activeUser: User | undefined;
  isUserURLParameter: boolean;
  customUserSign?: string;
}

const initialState: UserSliceInterface = {
  activeUser: undefined,
  isUserURLParameter: false,
};

export const UserSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | undefined>) => {
      state.activeUser = action.payload;
      state.isUserURLParameter = false;
    },
    setUserFromURL: (state, action: PayloadAction<User | undefined>) => {
      state.activeUser = action.payload;
      state.isUserURLParameter = true;
    },
    setCustomUserSign: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.customUserSign = action.payload;
    },
    setUserFromSign: (state, action: PayloadAction<User>) => {
      state.activeUser = action.payload;
      state.isUserURLParameter = true;
      state.customUserSign = undefined;
    },
    resetUser: () => initialState,
  },
});

export const { setUser, resetUser, setUserFromURL, setCustomUserSign, setUserFromSign } =
  UserSlice.actions;

export const selectedUser = (state: RootState): User | undefined =>
  state.user.activeUser;

export const isUserURLParams = (state: RootState): boolean =>
  state.user.isUserURLParameter;

export const selectedCustomUserSign = (state: RootState): string | undefined =>
  state.user.customUserSign;

// eslint-disable-next-line import/no-default-export
export default UserSlice.reducer;
